// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"502":"vendor","792":"main"}[chunkId] + "." + {"502":"a52543fca73b79c65fda","792":"6730970997f36291e330"}[chunkId] + ".css";
};